import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, Field, FieldArray, SubmissionError } from 'redux-form'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@material-ui/core'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { VendorInfoFormContainer } from './styled'
import { validations, validateCase as vCase } from 'core/validate'

import r from 'reactotron-react-js'

const ContactModal = (props) => {
  const { valueForm, change, onClose, onSave, vendorIndex } = props

  useEffect(() => {
  }, [])

  const renderContact = ({ fields, meta: { error } }) => {
    return (
      <React.Fragment>
        <div className='rowFields'>
          <Button color='primary' onClick={() => fields.push()}>Add</Button>
        </div>
        {
          fields.map((contact, index) => 
            <div className='rowFields'>
              <Field 
                name={`${contact}.name`}
                label='Name' 
                require
                type={type.text} 
                component={FieldInput} 
              />
              <Field 
                name={`${contact}.tel`}
                label='Tel' 
                require
                type={type.text} 
                component={FieldInput} 
              />
              <Field 
                name={`${contact}.email`}
                label='Email' 
                require
                type={type.text} 
                component={FieldInput} 
              />
              <Button color='secondary' onClick={() => fields.remove(index)}>Remove</Button>
            </div>
          )
        }
        
      </React.Fragment>
    )
  }

  return (
    <Dialog open={true} maxWidth='md' fullWidth style={{ zIndex: 10 }}>
      <DialogTitle>Contacts</DialogTitle>
      <DialogContent>
        <VendorInfoFormContainer>
          <form>
            {
              (valueForm.contacts || []).map((c, i) => 
                <div className='rowFields'>
                  <Field 
                    name={`contacts[${i}].name`}
                    label='Name' 
                    require
                    type={type.text} 
                    component={FieldInput} 
                  />
                  <Field 
                    name={`contacts[${i}].tel`}
                    label='Tel' 
                    require
                    type={type.text} 
                    component={FieldInput} 
                  />
                  <Field 
                    name={`contacts[${i}].email`}
                    label='Email' 
                    require
                    type={type.text} 
                    component={FieldInput} 
                  />
                  <Button 
                    color='secondary' 
                    onClick={() => {
                      const clone = [...valueForm.contacts]
                      clone.splice(i, 1)
                      change('contacts', clone)
                    }}
                  >Remove</Button>
                </div>
              )
            }
            <div className='rowFields'>
              <Button color='primary' onClick={() => change('contacts', [...valueForm.contacts, { name: '', tel: '', email: '' }])}>Add</Button>
            </div>
          </form>
        </VendorInfoFormContainer>
      </DialogContent>
      <DialogActions>
        <Button 
          color='primary' 
          onClick={() => {
            onSave(valueForm.contacts, vendorIndex)
          }}
        >Save</Button>
        <Button color='secondary' onClick={() => onClose()} >Cancel</Button>
      </DialogActions>
    </Dialog>
  )
}

const mapStateToProps = (state, props) => {
  const vendorData = props.vendorData || {}
  const vf = getFormValues('formShortListContact')(state) || {}
  var vendCon  = (vendorData.contacts || []).length === 0 ? [{ name: '', tel: '', email: '' }] : vendorData.contacts || [{ name: '', tel: '', email: '' }] 
  return ({
    valueForm: vf,
    initialValues: {
      contacts: vf.contacts || vendCon
    }
  })
}
  
const mapDispatchToProps = {}

const ContactModalForm = reduxForm({
  form: 'formShortListContact'
})(ContactModal)

export default connect(mapStateToProps, mapDispatchToProps)(ContactModalForm)